"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryValueResolver = void 0;
const Option_1 = require("fp-ts/Option");
const function_1 = require("fp-ts/function");
const react_1 = __importDefault(require("react"));
const DictionaryProvider_1 = require("./DictionaryProvider");
const jst_dictionaries_1 = require("@summer/jst-dictionaries");
const defaultParser = (v) => (typeof v === 'string' ? v : JSON.stringify(v));
function DictionaryValueResolver({ selector, code, valueParser, defaultValue }) {
    return (0, function_1.pipe)((0, DictionaryProvider_1.useDictionaryContext)(), selector, (0, Option_1.chainNullableK)((dict) => dict[code]), (0, Option_1.chainNullableK)((a) => ((0, jst_dictionaries_1.isDictionaryItem)(a) ? a : null)), (0, Option_1.chainNullableK)((item) => item.value), (0, Option_1.map)((value) => react_1.default.createElement(react_1.default.Fragment, null, valueParser ? valueParser(value) : defaultParser(value))), (0, Option_1.getOrElse)(() => react_1.default.createElement(react_1.default.Fragment, null, defaultValue ?? '')));
}
exports.DictionaryValueResolver = DictionaryValueResolver;
